import { Instance } from 'mobx-state-tree';
import { OrganizationDtoModelBase } from './OrganizationDtoModel.base';

/* The TypeScript type of an instance of OrganizationDtoModel */
export interface OrganizationDtoModelType extends Instance<typeof OrganizationDtoModel.Type> {}

/* A graphql query fragment builders for OrganizationDtoModel */
export { selectFromOrganizationDto, organizationDtoModelPrimitives, OrganizationDtoModelSelector } from './OrganizationDtoModel.base';

/**
 * OrganizationDtoModel
 */
export const OrganizationDtoModel = OrganizationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
